<template>
  <div class='singleVersionItem'>
    <div class="title"> {{ title }}</div>
    <div class="value">{{ getValue(value?.num1) }}</div>
  </div>
</template>
<script>
export default {
  name: 'singleVersionItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    getValue(num) {
      if (num) {
        return num;
      }
      return "-";
    },
  },
  created() {
    
  }
}
</script>
<style lang='less' scoped>
 
 .singleVersionItem {
   margin-top: 20px;
   width: 100%;

   .title {
     font-size: 16px;
     font-weight: bold;
     color: #565656;
   }

   .value {
     margin-top: 10px;
     width: calc(100% - 10px);
     height: 46px;
     border: 0.5px solid #707070;
     border-radius: 2px;
     display: flex;
     align-items: center;
     padding-left: 10px;
   }

 }
</style>